import { ConfigureResource } from "../generated-api";
import ApiClient from "../nesterenko";

export class ApiConfigure {
  static async postConfigure(body: ConfigureResource) {
    const formData = new FormData();

    formData.append("name", body.name);
    formData.append("email", body.email);
    formData.append("message", body.message);

    if (body.phone) {
      formData.append("phone", body.phone);
    }

    if (body.files?.length) {
      body.files.forEach((file, index) => formData.append(`files[${index}]`, file));
    }

    return ApiClient.post(`/configure`, formData);
  }
}
